export const STORAGE_KEYS = {
  playerEmail: "playerMail",
  lastPlayerId: "lastPlayerId",
  sbpSession: "sbpPaymentSession",
  cardSession: "cardPaymentSession",
} as const;
